export default __webpack_public_path__ + "media/images/collect-core-shape-5-e5600d1f.svg";